import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Order } from 'types/schema-generated-types';
import { MastercodeActionClickHandler } from '../OrdersPage';
import OrderCard from './OrderCard';

export type Props = {
  orders: Order[];
  onActivateMastercodeClick: MastercodeActionClickHandler;
  onTransferMastercodeClick: MastercodeActionClickHandler;
};

const OrdersList = ({ orders, onActivateMastercodeClick, onTransferMastercodeClick }: Props) => (
  <Grid container direction="column" spacing={3}>
    {orders.map(order => (
      <Grid item key={`order-${order.id}`}>
        <OrderCard
          order={order}
          onActivateMastercodeClick={onActivateMastercodeClick}
          onTransferMastercodeClick={onTransferMastercodeClick}
        />
      </Grid>
    ))}
  </Grid>
);

export default OrdersList;
